import DangerWhiteIcon from "../../styles/icon/DangerWhite.svg";
import styles from "./ErrorBox.module.scss";

export default function ErrorBox({ text, setText }) {
  return (
    <div
      className={`${styles.container_styles_errorBox} ${
        text ? styles.block : styles.none
      }`}
    >
      <div className={styles.bg_styles_errorBox}></div>
      <div className={styles.container_of_message_error_box}>
        <div>
          <img src={DangerWhiteIcon} alt="" width={25} height={25} />
        </div>
        <div>{text}</div>
        <div style={{ fontSize: "17px" }} onClick={() => setText("")}>
          X
        </div>
      </div>
    </div>
  );
}
